import Vue from 'vue'
import Router from 'vue-router'
import AdminProducts from '@/components/AdminProducts'
import AdminReviews from '@/components/AdminReviews'
import AdminSlider from '@/components/AdminSlider'
import AdminOrders from '@/components/AdminOrders'
import AdminCategories from '@/components/AdminCategories'
import AdminPromotions from '@/components/AdminPromotions'
import AdminSettings from '@/components/AdminSettings/AdminSettings'
import AdminSettingsAbout from '@/components/AdminSettings/AdminSettingsAbout'
import AdminSettingsStaticPage from '@/components/AdminSettings/AdminSettingsStaticPage'
import AdminFilling from '@/components/AdminFilling'
import AdminRobots from '@/components/AdminRobots'
import Login from '@/components/Login'
import AdminProposals from '@/components/AdminProposals'
import AdminSettingsDeliveryTime from '@/components/AdminSettings/AdminSettingsDeliveryTime'
import AdminSettingsDeliveryDay from '@/components/AdminSettings/AdminSettingsDeliveryDay'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/products',
      name: 'products',
      component: AdminProducts
    },
    {
      path: '/reviews',
      name: 'reviews',
      component: AdminReviews
    },
    {
      path: '/slider',
      name: 'slider',
      component: AdminSlider
    },
    {
      path: '/promotions',
      name: 'promotions',
      component: AdminPromotions
    },
    {
      path: '/',
      name: 'home',
      component: AdminProducts
    },
    {
      path: '/orders',
      name: 'orders',
      component: AdminOrders
    },
    {
      path: '/categories',
      name: 'categories',
      component: AdminCategories
    },
    {
      path: '/settings/about',
      name: 'settings/about',
      component: AdminSettingsAbout
    },
    {
      path: '/settings/static-page',
      name: 'settings/static-page',
      component: AdminSettingsStaticPage
    },
    {
      path: '/settings',
      name: 'settings',
      component: AdminSettings
    },
    {
      path: '/proposals',
      name: 'proposals',
      component: AdminProposals
    },
    {
      path: '/filling',
      name: 'filling',
      component: AdminFilling
    },
    {
      path: '/robots',
      name: 'robots',
      component: AdminRobots
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/settings/deliveryhours',
      name: 'deliveryhours',
      component: AdminSettingsDeliveryTime
    },
    {
      path: '/settings/deliveryday',
      name: 'deliveryday',
      component: AdminSettingsDeliveryDay
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js